module.exports = __webpack_public_path__ + "img/third.2779c934.jpg";